import NotFreePlanCallout from "../../../../src/content/not-free-plan-callout.mdx";
import * as React from 'react';
export default {
  NotFreePlanCallout,
  React
};